import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

interface MedewerkerInfo {
    fullName: string;
    isActive: boolean;
}

// All the incoming values
interface IProps {
    medewerker: MedewerkerInfo;
    size?: "small" | "medium" | "large";
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const MedewerkerText = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const size = props.size || "medium";
    const { t } = useTranslation('common');
    

    return (
        <Typography variant="body1">
            {props.medewerker.fullName}{props.medewerker.isActive ? "" : <small className={classes.inactive}> - {t('notActive')}</small>}
        </Typography>
    )
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({
    inactive: {
        color: theme.palette.grey[500],
    }
 }));